import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

import AnimatedScreenWrapper from '@/components/PreSignupFlow/Components/AnimatedScreenWrapper';

import { TwoColumnWrapper as _TwoColumnWrapper, PageWrap } from '../../styles';

export const PaymentPageWrap = styled(PageWrap)<{
	backgroundColor?: string;
}>`
	background: ${({ backgroundColor }) => palette(backgroundColor ?? 'gradientCalmBrandDark')};
`;

// The max-height is calculated as the full height of the viewport,
// minus the top margin, top/bottom padding & border of modalBody.
export const PaymentWrapper = styled.div<{ $overflow?: boolean }>`
	display: flex;
	flex-direction: column;
	justify-content: stretch;
	align-items: stretch;
	width: 100%;

	${ifProp(
		'$overflow',
		css`
			max-height: calc(95vh - 7rem - 2px);
			overflow-y: auto;
		`,
	)}

	${minWidth('desktop')} {
		width: 700px;
	}
`;

export const TwoColumnWrapper = styled(_TwoColumnWrapper)`
	flex-direction: column;

	${minWidth('desktop')} {
		flex-direction: row;
		gap: 60px;
	}
`;

export const CTAContainer = styled.div`
	max-width: 560px;
	margin: auto;
	padding-bottom: 32px;

	${minWidth('tablet')} {
		padding-bottom: 54px;
	}
`;

export const PurchaseFormWrapper = styled(AnimatedScreenWrapper)`
	position: relative;
`;

export const PurchaseFormSubWrapper = styled.div`
	max-width: 750px;
	width: 100%;
	margin: auto;
	display: flex;
	flex-direction: column;
`;
